<template>
  <ReferFriend />
</template>

<script>
import ReferFriend from '@/components/ReferFriend'

export default {
  components: {
    ReferFriend
  }
}
</script>

<style></style>
